import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../http/http.service';
import { MemberFeeFullPrice } from '../../../models/member/member-fee/member-fee-full-price';

@Injectable({
    providedIn: 'root'
})
export class MemberFeeService extends HttpService {
    listMemberFeesHash(idMember: string): Observable<MemberFeeFullPrice[]> {
        const url = `memberfee/${idMember}`;

        return this.get(url, { app: 'payments', version: 1.1 });
    }
}
